import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { SEAMLESSVIEW_SOURCES } from '../seamless-rf-view-map/seamless-rf-view-map-cnst';

@Component({
  selector: 'app-seamless-rf-view-sidebar',
  templateUrl: './seamless-rf-view-sidebar.component.html',
  styleUrls: ['./seamless-rf-view-sidebar.component.scss']
})
export class SeamlessRfViewSidebarComponent implements OnInit {
  queryParams: any;
  isInitialLoad: boolean = false;
  sourceOptions: any
  selected: string;
  selectedSource: any;
  selectedStartDate: any = { required: true };
  selectedEndDate: any = { required: true };
  validation: boolean[] = new Array(5).fill(true);
  sDate: any;
  eDate: any;
  format: any = { value: 'yyyyMMdd' };
  minDate: any;
  maxDate: any;
  showDateAlert: boolean = false;

  constructor(private gisUtils: UtilsService, private route: ActivatedRoute, private router: Router) {
    const url = this.router.url;
    const urlparams = url.split('/');
    this.selected = urlparams[2];
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        this.selectedSource = this.queryParams['source']
        let sourceList = SEAMLESSVIEW_SOURCES
        this.sourceOptions = Object.keys(sourceList).map(key => {
          return { key: key, value: sourceList[key] }
        })
        this.setMinMaxDate()
        this.requestSelectedFilterParams()
      }
    })
  }

  onSubmit() {
    const start = new Date(this.selectedStartDate['value']);
    const end = new Date(this.selectedEndDate['value']);

    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset today's time to midnight

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (start.toDateString() === new Date().toDateString()) {
      // Case 1: Today
      start.setHours(8, 30, 0, 0);
      end.setTime(Date.now());
    } else {
      // Case 2 & 3: Yesterday or any other day (past/future)
      start.setHours(0, 10, 0, 0);
      end.setHours(23, 50, 0, 0);
    }

    this.selectedStartDate['value'] = start;
    this.selectedEndDate['value'] = end;

    const startMs = start.getTime();
    const endMs = end.getTime();
    console.log(startMs, endMs, "Milliseconds range");

    // Update query params
    let options = { ...this.queryParams };
    options['startDate'] = startMs;
    options['endDate'] = endMs;
    options['source'] = this.selectedSource;

    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    });
  }

  setMinMaxDate() {
    const now = new Date(Number(this.queryParams['endDate']));
    const start = new Date(Number(this.queryParams['startDate']));
    this.maxDate = new Date()
    this.selectedStartDate = { value: start, required: true };
    this.selectedEndDate = { value: now, required: true };
    const currentDate = new Date();
    const lastMonthDate = new Date();
    lastMonthDate.setMonth(currentDate.getMonth() - 1); // Set to one month before the current date
    this.minDate = lastMonthDate;
  }

  // setDates() {
  //   let sDate = new Date();
  //   sDate.setDate(sDate.getDate() - 1)
  //   this.selectedStartDate['value'] = new Date(sDate);
  //   this.selectedEndDate['value'] = new Date();
  //   this.setMinDate();
  //   this.maxDate = this.selectedEndDate['value']
  // }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'SEAMLESSVIEW';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  onSeamlessSourceChange() {
    let options = { ...this.queryParams }
    options['source'] = this.selectedSource;
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  onstartDateChange() {
    this.selectedEndDate['value'] = ''
  }

  onendDateChange() {
    if (this.isWithinOneDay(this.selectedStartDate['value'], this.selectedEndDate['value'])) {
      this.showDateAlert = false
    } else {
      this.selectedEndDate['value'] = ''
      this.showDateAlert = true
    }
  }

  isWithinOneDay(start: Date, end: Date): boolean {
    const differenceInMs = Math.abs(end.getTime() - start.getTime());
    const oneDayInMs = 24 * 60 * 60 * 1000; // 86400000 ms
    return differenceInMs <= oneDayInMs;
  }

}
